// extracted by mini-css-extract-plugin
export default {"toolbar":"EditableSection_toolbar__ecYkY","addButtonSpacing":"EditableSection_addButtonSpacing__GHdBu"};